module.exports = __webpack_public_path__ + "static/media/dante inline w new sword.983a24d7.png";